import { Alert } from 'antd';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import {
  getBlockedForExport,
  getHasValidQuery,
  getIsCleared,
} from 'selectors/search';

const txtPressSearch = 'Press Search to apply changes';
const txtSelectCategory = 'Select any category to perform search';

const styles = {
  alert: {
    paddingTop: 1,
    paddingBottom: 1,
    fontWeight: 'normal',
  },
};

/**
 * Alert component that warns users when search results are stale and need refreshing
 */
export const StaleResultsAlert = memo(() => {
  const blockedForExport = useSelector(getBlockedForExport);
  const isCleared = useSelector(getIsCleared);
  const hasValidQuery = useSelector(getHasValidQuery);

  // Don't display if there's nothing to refresh
  if (!blockedForExport || isCleared) return null;

  const descriptionText = hasValidQuery ? txtPressSearch : txtSelectCategory;

  return (
    <Alert type='warning' style={styles.alert} description={descriptionText} />
  );
});
